import type { FaireProductEntity } from "../../entity_types/product";

export const p_k62hp8ztbg: FaireProductEntity = {
  token: "p_k62hp8ztbg",
  type: "product",
  name: "Pureology Strength Cure Shampoo, 9 oz",
  brandToken: "b_gqb5ebspac",
  brandName: "Super Stock Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/e571b6debed203a69a1b7d9b7707dfc2755ffdecb9316774abc6779d8220950a.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.49,
  description:
    "Pureology Strength Cure Shampoo – 9 oz\n\nRestore the health and shine of your hair with Pureology Strength Cure Shampoo. This rich, gentle formula repairs and strengthens damaged or color-treated hair while preserving vibrant color. Infused with Pureology’s exclusive AntiFade Complex®, it leaves hair soft, manageable, and resilient with a fresh, clean scent.\n\nFeatures:\n\n * Size: 9 fl oz (266 mL) \n * Repairs and strengthens damaged hair \n * Protects color and adds shine \n * Formulated with keravis, astaxanthin, and arginine \n * 100% vegan and sulfate-free \n * Safe for color-treated hair \n * Salon-quality results at home \nCondition: New – Unused, Unopened\n",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:05.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
